import { Injectable } from '@angular/core';
import {API_TYPE, HttpHelperService} from "../../../services/http-helper.service";

@Injectable({
  providedIn: 'root'
})
export class UserManagerService {

  constructor(
    private httpHelper: HttpHelperService,
  ) { }

  getUserInfo() {
    return this.httpHelper.get('user/getuser', {}, API_TYPE.USERMANAGER_API);
  }
  getAllUserRoles() {
    return this.httpHelper.get('user/GetAllUserRoles', {}, API_TYPE.USERMANAGER_API);
  }


  deleteNabonettAccount(formData: any) {
    return this.httpHelper.post('user/DeleteNabonettAccount', formData, API_TYPE.USERMANAGER_API);
  }


  updatePersonBankAc(data: { ID?: number, BankAc: string, IsPrimary: boolean, IsActive: boolean }) {
    return this.httpHelper.post('user/UpdatePersonBankAc', data, API_TYPE.USERMANAGER_API);
  }

  updatePersonAddress(data: { AddressId?: number, AddressLine1?: string, AddressLine2?: string, Zipcode?: string, City?: string, CountryID?: number, AddressTypeId?: number, IsPrimaryAddress: boolean, HasAddressRegistry?: boolean, AddressRegistryId?: number }) {
    return this.httpHelper.post('user/UpdatePersonAddress', data, API_TYPE.USERMANAGER_API);
  }
}
